module.exports = __webpack_public_path__ + "static/media/content.b035f183.jpg";